module.exports = __webpack_public_path__ + "media/images/dogs/chocolate-toxic-calculator-what-happens-if-it-is-consumed-in-large-quantities.jpg";